import { notificationQueryKeys as e } from "./notificationQueryKeys.mjs";
import { useMutation as t, useQueryClient as n } from "@maat/store-hooks";
import { notificationsApi as r } from "@maat/api-notifications";
//#region src/notifications/useMarkNotificationActionedMutation.ts
var i = () => {
	let i = n();
	return t({
		mutationFn: (e) => r.markActioned(e),
		onSuccess: () => {
			i.invalidateQueries({ queryKey: e.list() });
		}
	});
};
//#endregion
export { i as useMarkNotificationActionedMutation };
